import { Outlet } from "react-router-dom"

export const FullPageLayout = () => {
    return <Outlet />;
}